// hooks/useBrandsAndLocations.js
import { useState, useEffect } from 'react';
import { useGetOrgLocationsByUser } from '../app/useGetOrgLocationsByUser';
import { useGetAllBrands } from '../organisation/useGetAllBrands';
import { useProfileContext } from "../../context";

export const useBrandsAndLocations = (userId) => {
  const { userProfile } = useProfileContext();
  const { data: locationsData, isSuccess: isLocationsSuccess } = useGetOrgLocationsByUser(userId);
  const { data: brandsData, isSuccess: isBrandsSuccess } = useGetAllBrands(userProfile?.organisation_id);

  const [initialItems, setInitialItems] = useState([]);
  const [locationSelection, setLocationSelection] = useState([]);
  const [brandSelection, setBrandSelection] = useState([]);
  const [allLocations, setAllLocations] = useState([]);

  useEffect(() => {
    if (locationsData && locationsData.length > 0 && brandsData) {
      const items = [];
      const selectedLocations = [];
      const selectedBrands = [];
      
      // Find the default brand from brandsData
      const defaultBrand = brandsData.find(brand => brand.is_default);
      const defaultBrandId = defaultBrand?.id;
      
      // Add custom brands (non-default brands)
      if (brandsData && brandsData.length > 0) {
        brandsData.forEach(brand => {
          if (brand.id !== defaultBrandId) {
            items.push({
              value: `brand_${brand.id}`,
              label: `${brand.name} (Brand)`,
              type: 'brand',
              id: brand.id
            });
            // Select all custom brands by default
            selectedBrands.push(brand.id);
          }
        });
      }
      
      // Add independent locations (locations with default brand)
      locationsData.forEach(location => {
        if (location.brand_id === defaultBrandId) {
          items.push({
            value: location.id,
            label: location.name,
            type: 'location',
            id: location.id
          });
          selectedLocations.push(location.id);
        }
      });
      
      setInitialItems(items);
      setLocationSelection(selectedLocations);
      setBrandSelection(selectedBrands);
      setAllLocations(locationsData.map(location => location.id));
    }
  }, [locationsData, brandsData]);

  return {
    initialItems,
    locationSelection,
    setLocationSelection,
    brandSelection, 
    setBrandSelection,
    locationsData,
    brandsData,
    isLocationsSuccess,
    isBrandsSuccess,
    allLocations,
  };
};